import React from "react";
import {styled} from "@mui/material/styles";

export const ErrorText = styled('p')({
  color: 'red',
  fontSize: '0.8em',
  width: 'min(230px, 70vw)',
});
